import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Privacy Policy
          </h1>
          <p className="text-sm opacity-60 mb-8">Effective Date: April 9, 2026</p>

          <div className="space-y-6 text-[15px] leading-7 opacity-90">

            <section>
              <h2 className="text-lg font-semibold mb-2">1. Introduction</h2>
              <p>
                MoolTax ("we", "us", "our") is committed to protecting your personal information.
                This Privacy Policy explains how we collect, use, store, and protect data when
                you use our platform at mooltax.com.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">2. Information We Collect</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Name, email address, and phone number provided at registration</li>
                <li>Tax-related documents uploaded by you (Form 16, PAN, Aadhaar, bank statements, etc.)</li>
                <li>Payment transaction records (amount, status, gateway reference)</li>
                <li>Messages and communication history on the platform</li>
                <li>Technical data such as IP address, browser type, and usage logs</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">3. How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>To create and manage your account</li>
                <li>To process your tax filing requests and review uploaded documents</li>
                <li>To send transactional emails (verification, payment confirmation, case updates)</li>
                <li>To respond to support queries</li>
                <li>To comply with applicable legal and regulatory requirements</li>
                <li>To improve platform features and user experience</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">4. Data Storage and Security</h2>
              <p>
                Documents and account data are stored using secured cloud infrastructure with
                access controls and encryption in transit. We use industry-standard measures
                to protect your data, though no system can guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">5. Data Sharing</h2>
              <p>
                We do not sell your personal data. We may share information only with:
              </p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Technology and cloud service providers required to operate the platform</li>
                <li>Payment gateway providers to process transactions</li>
                <li>Email delivery services for transactional communications</li>
                <li>Regulatory or legal authorities if required by law</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">6. Data Retention</h2>
              <p>
                We retain your account and document data for as long as your account is active
                or as required for tax compliance and legal purposes. You may request deletion
                of your account by contacting us.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">7. Your Rights</h2>
              <p>
                You have the right to access, correct, or request deletion of your personal data.
                To exercise these rights, contact us at support@mooltax.com.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">8. Changes to This Policy</h2>
              <p>
                We may update this policy from time to time. Significant changes will be
                communicated via email or a notice on the platform.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">9. Contact</h2>
              <p>
                For any privacy-related queries, write to us at{" "}
                <a href="mailto:support@mooltax.com" className="underline">support@mooltax.com</a>.
              </p>
            </section>

          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default PrivacyPage;
